import React from 'react';
import classNames from 'classnames';
import Tab from './tab-v2';
import TabsHeader from './tabs-header-v2';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_NUMBER_OF_TABS = 3;
const Tabs = _ref => {
  let {
    activeTab = 0,
    tabHeadings,
    onTabHeadingClick,
    numberOfTabs = DEFAULT_NUMBER_OF_TABS,
    justifyHeaderStart = false,
    children
  } = _ref;
  const allIndex = Math.min(numberOfTabs - 1, (children === null || children === void 0 ? void 0 : children.length) || 0);
  const headings = [...tabHeadings].splice(0, numberOfTabs - 1).concat('All');
  const selectedTab = Math.min(allIndex, activeTab);
  return /*#__PURE__*/_jsxs("div", {
    "data-id": "tabs-v2_index_Tabs_div",
    children: [/*#__PURE__*/_jsx(TabsHeader, {
      selectedTab: selectedTab,
      headings: headings,
      className: classNames({
        [style.sessionTime]: justifyHeaderStart
      }),
      onTabHeadingClick: onTabHeadingClick,
      "data-id": "tabs-v2_index_Tabs_div_TabsHeader"
    }), selectedTab === allIndex ? /*#__PURE__*/_jsx(Tab, {
      isActive: true,
      role: "tabpanel",
      id: "tabpanel".concat(allIndex),
      "data-id": "tabs-v2_index_Tabs_Tab",
      children: children
    }) : children.splice(0, numberOfTabs).map((tab, i) => /*#__PURE__*/_jsx(Tab, {
      isActive: selectedTab === i,
      "aria-hidden": selectedTab !== i,
      role: "tabpanel",
      id: "tabpanel".concat(i),
      "data-id": "tabs-v2_index_Tabs_Tab_3",
      children: tab
    }, "tab".concat(i)))]
  });
};
export default Tabs;